<template>
    <div class="wrapper">
        <div class="header">
            <BaseHeader :title="'限时抢购'"/>
        </div>
        <div class="search-content">
            <div class="option-box">
                <div class="option-item" :class="active === 0 ? 'active' : ''" @click="handleChangeOption(0)">
                    <div class="option-txt">综合</div>
                    <div class="option-img">
                        <van-icon name="arrow-up" size="12" v-if="active1 === 0"/>
                        <van-icon name="arrow-down" size="12" v-else/>
                    </div>
                </div>
                <div class="option-item" :class="active === 1 ? 'active' : ''" @click="handleChangeOption(1)">
                    <div class="option-txt">销量</div>
                    <div class="option-img">
                        <van-icon name="arrow-up" size="12" v-if="active2 === 0"/>
                        <van-icon name="arrow-down" size="12" v-else/>
                    </div>
                </div>
                <div class="option-item" :class="active === 2 ? 'active' : ''" @click="handleChangeOption(2)">
                    <div class="option-txt">价格</div>
                    <div class="option-img">
                        <van-icon name="arrow-up" size="12" v-if="active3 === 0"/>
                        <van-icon name="arrow-down" size="12" v-else/>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="recommend-box goods-box">
                <div class="goods-list">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                        <div class="goods-item" v-for="item in goodsList" :key="item.id"
                             @click="handleGoDetails(item.id)">
                            <div>
                                <img v-lazy="item.logo" class="goods-img"/>
                                <p class="goods-name">
                                    <span class="tag" v-if="item.tag !== ''">{{ item.tag }}</span>
                                    {{ item.name }}
                                </p>
                                <p class="goods-price">
									<span class="new-price">
										￥ {{ item.sale_price }}
									</span>
                                    <span class="new-price" style="margin-left: auto;">
<!--										<van-button round color="#ff9900" size="mini">去购买</van-button>-->
										<button class="my-btn">去购买</button>
									</span>
                                </p>
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '../../components/BaseHeader';
import {getXsGoodsService} from '../../service/goodsService';
import {Toast} from 'vant';

export default {
    name: 'GoodsMuster',
    data() {
        return {
            goodsList: [],
            loading: false,
            finished: false,
            offset: {
                page: 0,
                limit: 10
            },
            typeId: null,
            searchKey: '', //搜索关键字
            active: 0, //搜索类别，0综合排序，1销量，2价格
            active1: 0,
            active2: 0,
            active3: 0,
            order: 0
        };
    },
    mounted() {
        this.typeId = this.$route.params.typeId;
        if (this.$route.params.searchKey == -1 || this.$route.params.searchKey === 'empty') {
            this.searchKey = '';
        } else {
            this.searchKey = this.$route.params.searchKey;
        }
        if (this.searchKey.length > 0) {
            let lock = true;
            const tempList = JSON.parse(localStorage.getItem('nearList')) || [];
            tempList.forEach(ele => {
                if (ele === this.searchKey) {
                    lock = false;
                }
            });
            if (lock) {
                if (tempList.length === 5) {
                    tempList.pop();
                }
                tempList.unshift(this.searchKey);
                localStorage.setItem('nearList', JSON.stringify(tempList));
            }
        }
    },
    methods: {
        goCategory() {
            this.$router.push({
                name: 'goodsCategory',
            });
        },
        getData() {
            this.offset.page++;
            var search = this.searchKey;
            if (this.searchKey.indexOf('bbb-') != -1) {
                this.searchKey = '';
            }
            getXsGoodsService(this.typeId, this.offset.page, this.offset.limit, this.active, this.order, search)
                .then(res => {
                    if (res.status === 1) {
                        this.loading = false;
                        if (res.datas.length === 0) {
                            this.finished = true;
                            return;
                        }
                        this.goodsList = [...this.goodsList, ...res.datas];
                    } else {
                        Toast(res.msg);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        //查看商品详情
        handleGoDetails(goodsId) {
            this.$router.push({
                name: 'goodsDetails',
                params: {
                    goodsId
                }
            });
        },

        //搜索
        handleSearch() {
            this.$router.push({
                name: 'search'
            });
        },

        //切换
        handleChangeOption(index) {
            if (index === 0) {
                if (this.active === index) {
                    this.active1 = this.active1 === 0 ? 1 : 0;
                }
            } else if (index === 1) {
                if (this.active === index) {
                    this.active2 = this.active2 === 0 ? 1 : 0;
                }
            } else if (index === 2) {
                if (this.active === index) {
                    this.active3 = this.active3 === 0 ? 1 : 0;
                }
            }
            if (this.active === index) {
                this.order = this.order === 0 ? 1 : 0;
            }
            this.active = index;
            this.goodsList = [];
            this.offset.page = 0;
            this.loading = false;
            this.finished = false;
            this.getData();
        }
    },
    components: {
        BaseHeader
    }
};
</script>

<style scoped lang="scss">
.my-btn {
  padding: 2px 10px 2px 10px;
  font-size: 10px;
  color: #fff;
  background: -webkit-gradient(linear, left bottom, right top, from(#00BFFF), to(#A9F0F8));
  background: linear-gradient(to top right, #00BFFF, #A9F0F8);
  border-radius: 12px;
  text-align: center;
  border: none;
}

.wrapper {
  background: #f7f7f7 !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  -webkit-scrollbar: 0px;

  .search-content {
    background-color: #FFFFFF;
    position: fixed;
    top: 46;
    padding: 5px 15px;
    box-sizing: border-box;
    z-index: 999;
    width: 100%;

    .option-box {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      height: 30px;

      .option-item {
        flex: 1;
        text-align: center;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .option-txt {
          font-size: 14px;
        }

        .option-img {
          display: flex;
        }
      }

      .active {
        color: #f20f20;
      }
    }
  }

  .content {
    background: #f7f7f7 !important;

    .goods-box {
      padding: 0 12px;
      box-sizing: border-box;

      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        img {
          height: 100px !important;
          width: 100%;
        }

        .text {
          position: absolute;
          right: 0;
          bottom: 0;
          color: #999999;
          display: flex;
          align-items: center;
        }
      }
    }

    .recommend-box {
      padding-top: 10px;
      // background: #F6F6F6;
      .goods-list {
        margin-top: 0px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        // justify-content: space-around;
        padding-top: 45px;

        .goods-item {
          border-radius: 5px;
          width: 48%;
          min-width: 155px;
          // box-sizing: border-box;
          margin-bottom: 10px;
          // box-shadow: 1px 1px 1px #ccc,
          // -1px -1px 1px #ccc;
          float: left;

          &:nth-child(2n) {
            margin-left: 7px;
          }

          &:nth-child(2n + 1) {
            margin-right: 7px;
          }

          div {
            background: #ffffff;
            border-radius: 5px;
            // border-top-left-radius: 5px;
            // border-top-right-radius: 5px;
            font-size: 16px;

            .goods-img {
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
              box-sizing: border-box;
              width: 100%;
              height: 156px;
            }

            .goods-name {
              font-size: 12px !important;
              color: #666;
              margin-top: 10px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              height: 35px;
            }

            .tag {
              background: #ff9900;
              color: #FFFFFF;
              font-size: 12px;
              padding: 2px 5px;
              margin-right: 5px;
              border-radius: 5px;
            }

            .goods-price {
              display: flex;
              margin-top: 6px;
              height: 20px;
              // justify-content: space-between;
              padding: 0 8px 15px;
              // box-sizing: border-box;
              .new-price {
                display: flex;
                align-items: center;
                color: #de3328;
                font-size: 15px;
                font-weight: bold;
              }

              .new-price img {
                margin-right: 5px;
              }

              .old-price {
                color: #d0d0d0;
                margin-left: 5px;
                font-size: 13px;
              }
            }

            .goods-price-img {
              width: 16px;
              height: 16px;
            }

            p {
              padding: 0 12px;
              box-sizing: border-box;
            }
          }
        }
      }

      .empty {
        text-align: center;
        padding: 15px 0;
      }
    }
  }
}
</style>
